var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ComIndex',{attrs:{"orderType":4,"exportTitle":"分级整期培训订单"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }